<template>
  <div class="article-list">
    <div class="list-header">
      <h2>文章管理</h2>
      <div class="header-right">
        <el-input v-model="keyword" placeholder="搜索标题或内容" size="small" clearable prefix-icon="el-icon-search" style="width: 240px; margin-right: 10px;" @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        <el-button size="small" icon="el-icon-search" style="margin-right: 10px;" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="openAdd">新增文章</el-button>
      </div>
    </div>
    <el-table :data="articles" border>
      <el-table-column prop="id" label="ID" width="40"></el-table-column>
      <el-table-column label="封面" width="70">
        <template slot-scope="scope">
          <img v-if="scope.row.coverImage" :src="scope.row.coverImage" class="cover-thumb" />
          <span v-else class="no-cover">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
      <el-table-column label="分类" width="80">
          <template slot-scope="scope">{{ scope.row.category?.name }}</template>
        </el-table-column>
        <el-table-column label="标签" width="80">
          <template slot-scope="scope">{{ formatTagNames(scope.row.tagIds) }}</template>
        </el-table-column>
        <el-table-column prop="readCount" label="阅读量" width="70"></el-table-column>
      <el-table-column prop="commentCount" label="评论数" width="70"></el-table-column>
      <el-table-column prop="likeCount" label="点赞数" width="70"></el-table-column>
      <el-table-column label="状态" width="70">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'published' ? 'success' : 'info'" size="small">
            {{ scope.row.status === 'published' ? '已发布' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="120"></el-table-column>
      <el-table-column label="操作" width="230">
        <template slot-scope="scope">
          <el-button size="mini" @click="editArticle(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status !== 'published'" size="mini" type="success" @click="publishArticle(scope.row.id)">发布</el-button>
          <el-button v-else size="mini" type="warning" @click="unpublishArticle(scope.row.id)">撤回</el-button>
          <el-button size="mini" type="danger" @click="deleteArticle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog :title="articleForm.id ? '编辑文章' : '新增文章'" :visible.sync="showAddModal" width="90%" top="3vh" :close-on-click-modal="false">
      <el-form :model="articleForm" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="articleForm.title" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="分类">
              <el-select v-model="articleForm.categoryId" placeholder="请选择分类" style="width: 100%">
                <el-option v-for="cat in categories" :key="cat.id" :label="cat.name" :value="cat.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签">
              <el-select v-model="articleForm.tagIds" multiple placeholder="请选择标签" style="width: 100%">
                <el-option v-for="tag in tags" :key="tag.id" :label="tag.name" :value="tag.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="articleForm.status" placeholder="请选择状态" style="width: 100%">
                <el-option label="发布" value="published"></el-option>
                <el-option label="存草稿" value="draft"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="封面图">
          <el-upload
            class="cover-upload"
            action=""
            :http-request="handleCoverUpload"
            :show-file-list="false"
            :before-upload="beforeCoverUpload"
            accept="image/*"
          >
            <img v-if="articleForm.coverImage" :src="articleForm.coverImage" class="cover-preview" />
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
          <el-button v-if="articleForm.coverImage" size="small" type="danger" @click="removeCover" style="margin-left: 10px;">移除封面</el-button>
        </el-form-item>
        <el-form-item label="内容类型">
          <el-radio-group v-model="articleForm.contentType" @change="onContentTypeChange">
            <el-radio label="markdown">Markdown 编辑器</el-radio>
            <el-radio label="rich">富文本编辑器</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="内容">
          <mavon-editor
            v-if="articleForm.contentType === 'markdown'"
            v-model="articleForm.content"
            :toolbars="markdownToolbars"
            :subfield="true"
            :defaultOpen="'edit'"
            :boxShadow="false"
            style="height: 500px; z-index: 1;"
            ref="mdEditor"
            language="zh-CN"
          />
          <quill-editor
            v-if="articleForm.contentType === 'rich'"
            v-model="articleForm.content"
            :options="quillOptions"
            style="height: 500px;"
            ref="quillEditor"
          />
        </el-form-item>
        <el-form-item label="摘要">
          <el-input type="textarea" :rows="3" v-model="articleForm.summary" placeholder="文章摘要（选填，留空则自动截取正文前200字）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAddModal = false">取消</el-button>
        <el-button type="primary" @click="saveArticle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { getArticles, getCategories, getTags, saveArticle, deleteArticle, publishArticleApi, unpublishArticleApi } from '@/api/blog'

export default {
  name: 'ArticleList',
  data() {
    return {
      articles: [],
      page: 1,
      size: 10,
      total: 0,
      keyword: '',
      showAddModal: false,
      categories: [],
      tags: [],
      markdownToolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        htmlcode: true,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        navigation: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true
      },
      quillOptions: {
        theme: 'snow',
        placeholder: '请输入文章内容...',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean']
          ]
        }
      },
      articleForm: {
        id: null,
        title: '',
        categoryId: null,
        tagIds: [],
        contentType: 'markdown',
        content: '',
        summary: '',
        coverImage: '',
        status: 'published'
      }
    }
  },
  mounted() {
    this.loadArticles()
    this.loadCategories()
    this.loadTags()
  },
  methods: {
    async loadArticles() {
      const res = await getArticles(this.page - 1, this.size, this.keyword)
      this.articles = res.data.content
      this.total = res.data.totalElements
    },
    handleSearch() {
      this.page = 1
      this.loadArticles()
    },
    async loadCategories() {
      const res = await getCategories()
      this.categories = res.data
    },
    async loadTags() {
      const res = await getTags()
      this.tags = res.data
    },
    handleSizeChange(val) {
      this.size = val
      this.loadArticles()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadArticles()
    },
    openAdd() {
      this.articleForm = {
        id: null,
        title: '',
        categoryId: null,
        tagIds: [],
        contentType: 'markdown',
        content: '',
        summary: '',
        coverImage: '',
        status: 'published'
      }
      this.showAddModal = true
    },
    editArticle(row) {
      this.articleForm = {
        id: row.id,
        title: row.title,
        categoryId: row.category ? row.category.id : row.categoryId,
        tagIds: row.tagIds ? (typeof row.tagIds === 'string' ? row.tagIds.split(',').map(Number) : row.tagIds) : [],
        contentType: row.contentType || 'markdown',
        content: row.content || '',
        summary: row.summary || '',
        coverImage: row.coverImage || '',
        status: row.status || 'published',
        createdAt: row.createdAt
      }
      this.showAddModal = true
    },
    onContentTypeChange() {
      this.articleForm.content = ''
    },
    beforeCoverUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    async handleCoverUpload(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      try {
        const res = await axios.post('http://localhost:9080/api/upload/image', formData)
        const baseURL = 'http://localhost:9080'
        this.articleForm.coverImage = baseURL + res.data.url
        this.$message.success('封面上传成功')
      } catch (e) {
        this.$message.error('上传失败')
      }
    },
    removeCover() {
      this.articleForm.coverImage = ''
    },
    async saveArticle() {
      if (!this.articleForm.title.trim()) {
        this.$message.warning('请输入文章标题')
        return
      }
      if (!this.articleForm.content.trim()) {
        this.$message.warning('请输入文章内容')
        return
      }
      const data = {
        id: this.articleForm.id,
        title: this.articleForm.title,
        content: this.articleForm.content,
        contentType: this.articleForm.contentType,
        summary: this.articleForm.summary,
        coverImage: this.articleForm.coverImage,
        tagIds: this.articleForm.tagIds ? this.articleForm.tagIds.join(',') : '',
        category: this.articleForm.categoryId ? { id: this.articleForm.categoryId } : null,
        status: this.articleForm.status,
        createdAt: this.articleForm.createdAt
      }
      await saveArticle(data)
      this.showAddModal = false
      this.loadArticles()
      this.$message.success('保存成功')
    },
    async deleteArticle(id) {
      try {
        await this.$confirm('确定要删除这篇文章吗？', '提示', { type: 'warning' })
        await deleteArticle(id)
        this.loadArticles()
        this.$message.success('删除成功')
      } catch (e) {}
    },
    async publishArticle(id) {
      await publishArticleApi(id)
      this.loadArticles()
      this.$message.success('发布成功')
    },
    async unpublishArticle(id) {
      await unpublishArticleApi(id)
      this.loadArticles()
      this.$message.success('已撤回为草稿')
    },
    formatTagNames(tagIds) {
      if (!tagIds) return ''
      const ids = typeof tagIds === 'string' ? tagIds.split(',').map(Number) : tagIds
      return ids.map(id => {
        const tag = this.tags.find(t => t.id === id)
        return tag ? tag.name : ''
      }).filter(Boolean).join('、')
    }
  }
}
</script>

<style scoped>
.article-list {
  padding: 20px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.list-header h2 {
  margin: 0;
}

.el-table {
  margin-bottom: 20px;
}

.cover-upload {
  display: inline-block;
}

.cover-upload .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-upload .el-upload:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.cover-preview {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.cover-thumb {
  width: 50px;
  height: 38px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.no-cover {
  color: #c0c4cc;
}
</style>
